import {
  WorkerRequirementMappingLevel,
  WorkerRequirementStatus,
} from "@clipboard-health/contract-worker-app-bff";
import { isDefined } from "@clipboard-health/util-ts";
import { isEmpty } from "lodash";

import { type PlacementDetail } from "../../Placements/api/useGetPlacement";
import { type PlacementData } from "../../Placements/types/placement";
import { type WorkerRequirement } from "../api/types";
import { type MissingCredentialType } from "../types";

export function mapPlacementDetailRequirementsToPlacementDataRequirements(
  workerRequirements: PlacementDetail["credentialRequirements"] | undefined
): PlacementData["credentialRequirements"] | undefined {
  if (!isDefined(workerRequirements)) {
    return undefined;
  }

  return workerRequirements.map((requirement) => ({
    ...requirement.attributes,
    id: requirement.id,
    requirement: {
      ...requirement.relationships.requirement.data.attributes,
      id: requirement.relationships.requirement.data.id,
    },
  }));
}

export function calculateMissingCredential(
  credentialRequirements: WorkerRequirement[] | PlacementData["credentialRequirements"]
): MissingCredentialType | null {
  if (!isDefined(credentialRequirements) || isEmpty(credentialRequirements)) {
    return null;
  }

  const hasMissingWorkplaceCredentials = credentialRequirements.some(
    (requirement) =>
      requirement.level === WorkerRequirementMappingLevel.HCF &&
      requirement.status !== WorkerRequirementStatus.APPROVED
  );

  if (hasMissingWorkplaceCredentials) {
    return "WORKPLACE_CREDENTIAL";
  }

  const hasMissingBaseCredentials = credentialRequirements.some(
    (requirement) =>
      requirement.level === WorkerRequirementMappingLevel.STATE &&
      requirement.status !== WorkerRequirementStatus.APPROVED
  );

  return hasMissingBaseCredentials ? "BASE_CREDENTIAL" : null;
}
